// extracted by mini-css-extract-plugin
module.exports = {"strike-through":"strike-through__27a3y","line":"line__xWdQe","gray":"gray__1soJW"};